/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as begin from './ageassurance/begin'
export * as defs from './ageassurance/defs'
export * as getConfig from './ageassurance/getConfig'
export * as getState from './ageassurance/getState'
